module.exports = require("path/posix");